//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'ModalAuth',

  props: {
    visible: Boolean
  },

  data() {
    return {
      form: {
        username: '',
        rules: false
      },
      isLoading: false,
      validators: {
        username: {
          trigger: 'blur',
          validator: (rule, value, callback) => {
            const regex = /^[a-zA-Zа-яА-Я0-9_\d\s]{5,20}$/

            if (this.form) {
              if (this.form.username.length === 0) {
                return callback(new Error(`Поле обязательное!`))
              }

              if (!this.form.username?.match(regex) ) {
                return callback(new Error(`Никнейм должен содержать от 5 до 20 символов: цифры [ 0…9 ] или русские/латинские буквы, так же можно использовать "_" и пробел`))
              }
            }

            return callback()
          }
        },
      }
    }
  },

  methods: {
    onSubmit() {
      this.$refs.ruleForm.validate(async (valid, errors) => {
        if (!valid) {
          const fields = {
            username: "Никнейм",
          }

          let message = []
          Object.keys(errors).map(key => {
            message.push({
              name: `${fields[key.split('.')[0]] || fields[key.split('[')[0]]}`,
              message: `${errors[key].map(x => x.message).join(',').toLowerCase()}`
            })
          })

          this.$info({
            title: "Исправьте следующие ошибки",
            content: function (h) {
              return h('div', {}, [
                message.map(item => {
                  return h('div', {}, [
                    h('strong', `${item.name}: `),
                    h('span', item.message)
                  ])
                })
              ])
            }
          })

          return
        }

        this.isLoading = true

        await this.$axios.post(`${process.env.BASE_URL_V2}/auth/register_with/`, { provider: this.$route.query.provider, state: this.$route.query.state, id: this.$route.query.id, nickname: this.form.username })
          .then(async (response) => {
            if (response.data && response.data.access_token) {
              await this.$auth.setUserToken(response.data.access_token);
              await this.$auth.fetchUser();

              this.$store.dispatch('auth_modals/showNicknameModal', false)
              this.$message.success('Вы успешно зарегистрировались')
            }
          }).catch((err) => {
            if (err.response && err.response.status && err.response.status === 401) {
              if (err.response.data?.detail === 'USER_EXISTS') {
                this.$message.error('Такой никнейм уже существует. Придумайте другой')
              } else {
                this.$message.error('Аккаунт уже создан')
              }
            } else {
              this.$message.error('Что-то пошло не так')
            }
          }).finally(() => {
            this.isLoading = false
          })
      });
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    cancelModal() {
      this.resetForm()
      this.$emit('cancel')
    }
  }
}
